import * as React from "react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { JoinVideoMeetingButton } from "./JoinVideoMeetingButton";

interface Props {
    task: TaskModel;
    creatingMeeting: boolean;
}

export const VideoMeetingsUpper: React.FunctionComponent<Props> = (props: Props) => {
    if (props.task.completed || props.task.cancelled) {
        return null;
    }

    if (props.task.isVideoAppointmentTask) {
        return (
            <>
                <div className="video-meetings-right">
                    <JoinVideoMeetingButton task={props.task} creatingMeeting={props.creatingMeeting} />
                </div>
            </>
        );
    }

    return null;
};
